const container = document.getElementById('main-container');
if(container){
function adjustContainerClass() {
    
    if (window.innerWidth < 768) {
      container.classList.remove('container');
      container.classList.add('container-fluid');
      container.classList.add('p-0');
    } else {
      container.classList.remove('container-fluid');
      container.classList.remove('p-0');
      container.classList.add('container');
    }
  }
  adjustContainerClass();

  window.addEventListener('resize', adjustContainerClass);
}